import { css } from '@emotion/react';

const getNotificationViewCss = css`
  padding: var(--cds-spacing-300);
  border-bottom-left-radius: var(--cds-border-radius-200);
  border-bottom-right-radius: var(--cds-border-radius-200);
  border: 1px solid var(--cds-color-neutral-stroke-primary-weak);
  border-top: none;
`;

export default getNotificationViewCss;
